!function() {
  function e(e, t, i, s) {
    Object.defineProperty(e, t, {
      get: i,
      set: s,
      enumerable: !0,
      configurable: !0
    });
  }
  function t(e) {
    return e && e.__esModule ? e.default : e;
  }
  var i = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, s = {}, n = {}, r = i.parcelRequire5f74;
  null == r && ((r = function(e) {
    if (e in s) return s[e].exports;
    if (e in n) {
      var t = n[e];
      delete n[e];
      var i = {
        id: e,
        exports: {}
      };
      return s[e] = i, t.call(i.exports, i, i.exports), i.exports;
    }
    var r = new Error("Cannot find module '" + e + "'");
    throw r.code = "MODULE_NOT_FOUND", r;
  }).register = function(e, t) {
    n[e] = t;
  }, i.parcelRequire5f74 = r), (0, r.register)("57rjy", function(t, i) {
    function s(e) {
      window.onTagalysReady ? window.onTagalysReady(e) : console.warn("Tagalys configuration not found. Make sure Tagalys is enabled in theme settings.");
    }
    function n(e) {
      const t = "undefined" != typeof Shopify && Shopify.locale && Shopify.country ? `${Shopify.locale}-${Shopify.country}` : "en-GB", i = "undefined" != typeof Shopify && Shopify.currency && Shopify.currency.active ? Shopify.currency.active : "GBP", s = e % 1 != 0;
      return new Intl.NumberFormat(t, {
        style: "currency",
        currency: i,
        minimumFractionDigits: s ? 2 : 0,
        maximumFractionDigits: s ? 2 : 0
      }).format(e);
    }
    function r(e, t, i = "") {
      if (!e || "undefined" == typeof Shopify || !Shopify.getSizedImage) return `\n      <img\n        src="${e}"\n        alt="${t}"\n        class="${i}"\n        loading="lazy"\n        width="400"\n        height="467"\n      />\n    `;
      const s = [ 320, 414, 600, 768, 1024, 1280, 1440, 1600, 1920 ].map(t => `${Shopify.getSizedImage(e, t + "x")} ${t}w`).join(", ");
      return `\n    <img\n      src="${Shopify.getSizedImage(e, "400x")}"\n      srcset="${s}"\n      sizes="(min-width: 1024px) 22.5vw, 47.5vw"\n      alt="${t}"\n      class="${i}"\n      loading="lazy"\n      width="400"\n      height="467"\n    />\n  `;
    }
    function a(e, t = {}) {
      const {enableCarousel: i = !1} = t;
      if (!e.images || 0 === e.images?.length) return "";
      const s = e.price, a = e.compare_at_price, c = a && a > s, o = e.price_varies || e.price_min !== e.price_max, l = n(s), d = a ? n(a) : null, h = o ? n(e.price_min) : null, u = o ? n(e.price_max) : null, p = e.title.split("|"), g = p[0] || e.title, v = p[1] || "", f = p[2] || "", y = (parseInt(e.metafields?.custom?.product_variations?.value?.length), 
      (e.metafields?.my_fields?.custom_sticker?.value || "").split("|")[0].trim());
      let m;
      if (i && e.images.length > 1) S = e.images, w = g, m = `\n    <vanilla-slider>\n      <div class="slider gap-0" data-slider>\n        ${S.map(e => `\n      <div class="slide w-full">\n        ${r(e.src || e, e.alt || w, "w-full object-cover aspect-[5/7]")}\n      </div>\n    `).join("")}\n      </div>\n    </vanilla-slider>\n  `; else {
        const t = e.featured_image || e.images[0];
        m = r(t.src || t, t.alt || g, "w-full object-cover aspect-[5/7]");
      }
      var S, w;
      return `\n    <product-card class="block relative">\n      <a\n        class="\n          flex flex-col gap-3\n          tablet:gap-2.5\n          group\n          peer\n        "\n        href="${window.Shopify?.routes?.root || "/"}products/${e.handle}"\n      >\n        <div class="relative">\n          <div\n            class="\n              product-card__details absolute top-2 left-2\n              tablet:top-2.5 tablet:left-2.5\n            "\n          >\n            ${y ? `<div class="text-xs bg-scheme-contrast text-primary-button-text py-1 px-2.5">${y}</div>` : ""}\n          </div>\n\n          <div data-media-container>\n            ${m}\n          </div>\n        </div>\n\n        <div\n          class="\n            product-card__details flex gap-3\n            tablet:px-3\n            px-5 flex-col\n          "\n        >\n          <div class="text-scheme-links">\n            <div class="text-md desktop:flex justify-between gap-1">\n              <div class="flex flex-col truncate">\n                <span>${g}</span>\n                <span>${v}</span>\n                <span>${f}</span>\n              </div>\n\n              \n            </div>\n          </div>\n\n          <div class="text-sm">\n            ${o ? `\n              <div class="text-scheme-links">\n                ${h} – ${u}\n              </div>\n            ` : `\n              <span\n                class="${c ? "text-scheme-contrast" : "text-scheme-links"}"\n                data-price\n              >\n                ${l}\n              </span>\n\n              ${c ? `\n                <s\n                  class="text-scheme-text"\n                  aria-label="Was ${d}"\n                  data-compare-at-price\n                >\n                  ${d}\n                </s>\n              ` : ""}\n            `}\n          </div>\n        </div>\n      </a>\n    </product-card>\n  `;
    }
    e(t.exports, "onTagalysReady", function() {
      return s;
    }), e(t.exports, "createResponsiveImage", function() {
      return r;
    }), e(t.exports, "createProductCardHTML", function() {
      return a;
    });
  });
  var a = r("57rjy"), c = {};
  function o(e, t = 100, i = {}) {
    if ("function" != typeof e) throw new TypeError(`Expected the first parameter to be a function, got \`${typeof e}\`.`);
    if (t < 0) throw new RangeError("`wait` must not be negative.");
    const {immediate: s} = "boolean" == typeof i ? {
      immediate: i
    } : i;
    let n, r, a, c, o;
    function l() {
      const t = n, i = r;
      return n = void 0, r = void 0, o = e.apply(t, i), o;
    }
    function d() {
      const e = Date.now() - c;
      e < t && e >= 0 ? a = setTimeout(d, t - e) : (a = void 0, s || (o = l()));
    }
    const h = function(...e) {
      if (n && this !== n && Object.getPrototypeOf(this) === Object.getPrototypeOf(n)) throw new Error("Debounced method called with different contexts of the same prototype.");
      n = this, r = e, c = Date.now();
      const i = s && !a;
      return a || (a = setTimeout(d, t)), i && (o = l()), o;
    };
    return Object.defineProperty(h, "isPending", {
      get: () => void 0 !== a
    }), h.clear = () => {
      a && (clearTimeout(a), a = void 0);
    }, h.flush = () => {
      a && h.trigger();
    }, h.trigger = () => {
      o = l(), h.clear();
    }, h;
  }
  c.debounce = o, c = o;
  class l extends HTMLElement {
    constructor() {
      super(), this.query = this.dataset.query || "", this.checkbox = document.getElementById("Search"), 
      this.input = this.querySelector('input[type="search"]'), this.predictiveSearchSuggestions = this.querySelector("#predictive-search-suggestions"), 
      this.predictiveSearchResults = this.querySelector("#predictive-search-results"), 
      this.predictiveSearchProducts = this.querySelector("#predictive-search-products"), 
      this.predictiveSearchDesktopProducts = this.querySelector("#predictive-search-desktop-products"), 
      this.predictiveSearchQuerySuggestions = this.querySelector("#predictive-search-query-suggestions"), 
      this.predictiveSearchCollectionResults = this.querySelector("#predictive-search-collection-results"), 
      this.predictiveSearchPageResults = this.querySelector("#predictive-search-page-results"), 
      this.searchInstance = null, this.isInitialized = !1, this.checkbox && this.checkbox.addEventListener("change", () => {
        this.checkbox.checked ? (this.loadSuggestedQueries(), this.querySelector('input[type="search"]').focus(), 
        this.query && "" !== this.query && (this.input && (this.input.value = this.query), 
        this.isInitialized || this.initializeTagalys(), this.onChange()), this.toggleClearButton(), 
        this.toggleBodyScroll(!0)) : this.toggleBodyScroll(!1);
      }), this.input && (this.input.addEventListener("input", t(c)(e => {
        this.onChange(e), this.toggleClearButton();
      }, 300).bind(this)), this.input.addEventListener("input", () => {
        this.toggleClearButton();
      }), this.toggleClearButton(), this.input.addEventListener("focus", () => {
        this.predictiveSearchResults && this.predictiveSearchResults.classList.add("tablet:pb-[55vh]"), 
        this.predictiveSearchSuggestions && this.predictiveSearchSuggestions.classList.add("tablet:pb-[55vh]");
      }), this.input.addEventListener("blur", () => {
        this.predictiveSearchResults && this.predictiveSearchResults.classList.remove("tablet:pb-[55vh]"), 
        this.predictiveSearchSuggestions && this.predictiveSearchSuggestions.classList.remove("tablet:pb-[55vh]");
      })), (0, a.onTagalysReady)(() => {
        this.initializeTagalys();
      }), this.addEventListener("click", this.handleSuggestionClick.bind(this)), this.addEventListener("click", this.handleClearClick.bind(this)), 
      this.setupKeyboardHandling();
    }
    setupKeyboardHandling() {
      const e = this.querySelector('button[type="submit"]');
      if (!e) return;
      const t = getComputedStyle(e).bottom, i = () => {
        if (window.innerWidth <= 768) {
          const i = window.visualViewport ? window.visualViewport.height : window.innerHeight, s = window.innerHeight - i;
          e.style.bottom = s > 150 ? `${s}px` : t;
        }
      };
      window.visualViewport ? window.visualViewport.addEventListener("resize", i) : window.addEventListener("resize", i), 
      this.input && (this.input.addEventListener("focus", () => {
        setTimeout(i, 300);
      }), this.input.addEventListener("blur", () => {
        setTimeout(i, 300);
      }));
    }
    handleSuggestionClick(e) {
      const t = e.target.closest("[data-suggestion]");
      if (t) {
        e.preventDefault();
        const i = t.textContent.trim();
        this.input && i && (this.input.value = i, this.query = i, this.onChange(), this.toggleClearButton());
      }
    }
    handleClearClick(e) {
      e.target.closest("[data-clear-search]") && (e.preventDefault(), this.input && (this.input.value = "", 
      this.query = "", this.onChange(), this.toggleClearButton(), this.input.focus()));
    }
    toggleClearButton() {
      const e = this.querySelector("[data-clear-search]");
      if (!e || !this.input) return;
      this.input.value.trim().length > 0 ? e.classList.remove("hidden") : e.classList.add("hidden");
    }
    toggleBodyScroll(e) {
      document.body.classList.toggle("overflow-hidden", e);
    }
    initializeTagalys() {
      if (!this.isInitialized) try {
        this.searchInstance = window.Tagalys.APIConnector.SearchSuggestions.new({
          params: {
            query: this.query,
            sections: {
              products: {
                count: 12,
                include: [ "total_count", "items" ]
              },
              collections: {
                count: 3
              },
              pages: {
                count: 3
              }
            }
          },
          onSuccess: (e, t) => {
            this.renderSearchResults(e);
          },
          onFailure: (e, t) => {
            console.warn("Tagalys search suggestions failed:", e);
          }
        }), this.isInitialized = !0;
      } catch (e) {
        console.warn("Failed to initialize Tagalys search suggestions:", e);
      }
    }
    loadSuggestedQueries() {
      this.loadingSuggestions || (this.loadingSuggestions = !0, (0, a.onTagalysReady)(() => {
        this.searchInstance || this.initializeTagalys(), this.searchInstance ? this.searchInstance.helpers.getPopularSearches(3).then(e => {
          let t = "";
          e.forEach(e => {
            t += `<li\n                      class="leading-none"\n                      role="option"\n                      aria-selected="false"\n                    >\n                      <a\n                        href="${window.Shopify?.routes?.root || "/"}search?q=${encodeURIComponent(e.query)}"\n                        class="inline-block text-scheme-links text-md first-letter:uppercase"\n                        tabindex="0"\n                        data-suggestion\n                      >\n                        ${e.query}\n                      </a>\n                    </li>`;
          }), this.predictiveSearchQuerySuggestions.innerHTML = t, this.loadingSuggestions = !1;
        }) : console.warn("Tagalys search instance not initialized");
      }));
    }
    loadSuggestedProducts() {
      if (this.loadingProducts) return;
      this.loadingProducts = !0;
      const e = this.dataset.suggestionsWidget;
      if (!e) return console.warn("No suggestions widget ID provided"), this.loadingProducts = !1, 
      void this.show();
      (0, a.onTagalysReady)(() => {
        try {
          window.Tagalys.APIConnector.Recommendations.call({
            params: {
              recommendationId: e,
              count: 9
            },
            onSuccess: e => {
              this.renderSuggestedProducts(e), this.loadingProducts = !1;
            },
            onFailure: e => {
              console.warn("Tagalys recommendations failed:", e), this.loadingProducts = !1, this.show();
            }
          });
        } catch (e) {
          console.warn("Failed to load Tagalys recommendations:", e), this.loadingProducts = !1, 
          this.show();
        }
      });
    }
    renderSuggestedProducts(e) {
      const t = this.querySelector("#predictive-search-products");
      if (t) {
        if (e.products && e.products.length > 0) {
          let i = "";
          e.products.forEach(e => {
            i += (0, a.createProductCardHTML)(e, {
              disableCarousel: !0
            });
          }), t.innerHTML = i;
        }
        this.show();
      }
    }
    renderSuggestedCategories(e) {
      const t = this.querySelector("#predictive-search-categories");
      if (t) {
        if (e && e.length > 0) {
          let i = "";
          e.forEach(e => {
            const t = e.image, s = e.title, n = e.link;
            i += `<a\n                  href="${n}"\n                  class="\n                    flex flex-col gap-3\n                    tablet:gap-2.5\n                  "\n                  tabindex="0"\n                  data-suggestion\n                  role="option"\n                  aria-selected="false"\n                >\n                  ${(0, 
            a.createResponsiveImage)(t, s, "w-full object-cover")}\n                  <div class="text-md text-scheme-links uppercase">${s}</div>\n                </a>`;
          }), t.innerHTML = i;
        }
        this.show();
      }
    }
    show() {
      this.querySelector("#predictive-search-suggestions").classList.add("opacity-100");
    }
    onChange() {
      const e = this.input.value.trim();
      if (this.query = e, !e.length) return this.predictiveSearchSuggestions && this.predictiveSearchSuggestions.classList.remove("hidden"), 
      this.predictiveSearchResults && this.predictiveSearchResults.classList.add("hidden"), 
      this.predictiveSearchProducts && this.predictiveSearchProducts.classList.add("hidden"), 
      void (this.predictiveSearchDesktopProducts && this.predictiveSearchDesktopProducts.classList.add("hidden"));
      this.predictiveSearchSuggestions && this.predictiveSearchSuggestions.classList.add("hidden"), 
      this.predictiveSearchResults && this.predictiveSearchResults.classList.remove("hidden"), 
      this.isInitialized && this.searchInstance && this.searchInstance.helpers.updateQuery(e);
    }
    renderSearchResults(e) {
      const t = e.sections || {};
      let i = "";
      if (t.products && t.products.items.length > 0) {
        if (i = "", t.products.items.forEach(e => {
          i += (0, a.createProductCardHTML)(e);
        }), this.predictiveSearchProducts) {
          this.predictiveSearchProducts.classList.remove("hidden");
          let e = "";
          t.products.items.slice(0, 9).forEach(t => {
            e += (0, a.createProductCardHTML)(t);
          });
          (this.predictiveSearchProducts.querySelector("[data-container]") || this.predictiveSearchProducts).innerHTML = e;
        }
        if (this.predictiveSearchDesktopProducts) {
          this.predictiveSearchDesktopProducts.classList.remove("hidden");
          let e = "";
          t.products.items.forEach(t => {
            e += (0, a.createProductCardHTML)(t);
          });
          (this.predictiveSearchDesktopProducts.querySelector("[data-container]") || this.predictiveSearchDesktopProducts).innerHTML = e;
        }
      } else if (this.query && this.query.trim().length > 0) {
        const e = window.strings.search.noResults.replace("{{ terms }}", this.query);
        if (this.predictiveSearchProducts) {
          this.predictiveSearchProducts.classList.remove("hidden");
          const t = this.predictiveSearchProducts.querySelector("[data-container]") || this.predictiveSearchProducts;
          t.innerHTML = "", t.insertAdjacentHTML("beforeend", `\n          <div class="text-scheme-text text-lg px-offset text-center col-span-3">${e}</div>`);
        }
        if (this.predictiveSearchDesktopProducts) {
          this.predictiveSearchDesktopProducts.classList.remove("hidden");
          const t = this.predictiveSearchDesktopProducts.querySelector("[data-container]") || this.predictiveSearchDesktopProducts;
          t.innerHTML = "", t.insertAdjacentHTML("beforeend", `\n          <div class="text-scheme-text text-lg px-offset py-20 text-center col-span-4">${e}</div>`);
        }
      }
      t.collections && t.collections.items.length > 0 && this.predictiveSearchCollectionResults && (i = "", 
      t.collections.items.forEach((e, t) => {
        i += `<li\n                  class="leading-none"\n                  role="option"\n                  aria-selected="false"\n                  ${t > 3 ? 'class="tablet:hidden"' : ""}\n                >\n                  <a\n                    href="${e.link}"\n                    class="text-scheme-text text-md"\n                    tabindex="0"\n                  >\n                    ${this.highlightQuery(e.title)}\n                  </a>\n                </li>`;
      }), this.predictiveSearchCollectionResults.innerHTML = i), t.pages && t.pages.items.length > 0 && this.predictiveSearchPageResults && (i = "", 
      t.pages.items.forEach((e, t) => {
        i += `<li\n                  role="option"\n                  aria-selected="false"\n                  ${t > 3 ? 'class="tablet:hidden"' : ""}\n                >\n                  <a\n                    href="${e.link}"\n                    class="text-scheme-text text-md"\n                    tabindex="0"\n                  >\n                    ${this.highlightQuery(e.title)}\n                  </a>\n                </li>`;
      }), this.predictiveSearchPageResults.innerHTML = i);
    }
    highlightQuery(e, t = this.query) {
      if (!t) return e;
      const i = new RegExp(`(${t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`, "gi");
      return e.replace(i, '<span class="text-scheme-links">$1</span>');
    }
  }
  customElements.get("search-drawer") || customElements.define("search-drawer", l);
}();